/**
 * Grafikon komponens
 * @author Koppany Kiss 2017.05.22.
 */
import grafikonContainerTemplate from './grafikon-container.pug';
import grafikonForm from './../grafikon-form/grafikon-form';
import grafikonMegjelenito from './../grafikon-megjelenito/grafikon-megjelenito';
import arfolyamServiceModule from './../../services/arfolyam-service';

const MODULE_NAME = 'grafikonContainer';
class GrafikonContainerController {
	constructor(arfolyamService, $rootScope) {
		'ngInject';
		this.arfolyamService = arfolyamService;
		this.rootScope = $rootScope;
		this.showLoader = false;
		this.showGrafikon = false;
		this.notEnoughData = false;
	}

	$onInit() {
		this.arfolyamService.getGrafikonInitDates().then(
			(response) => {
				this.initData = response.data;
			}, (error) => {
				this.error = error;
				this.rootScope.$broadcast('serverError');
			});
	}

	getGrafikon(requestModel) {
		this.notEnoughData = false;
		this.showGrafikon = false;
		this.showLoader = true;

		this.arfolyamService.getArfolyam(requestModel).then(
			(response) => {
				this.showLoader = false;
				this.chartOptions = this.arfolyamService.getPortfolioChartAdatok(response.data);

				if (!this.chartOptions) {
					this.notEnoughData = true;
				} else {
					this.showGrafikon = true;
				}
			}, (error) => {
				this.showLoader = false;
				this.rootScope.$broadcast('serverError');
				this.error = error;
		});
	}
}

export default angular.module(MODULE_NAME, [arfolyamServiceModule, grafikonForm, grafikonMegjelenito])
	.component('grafikonContainer', {
		controller: GrafikonContainerController,
		template: grafikonContainerTemplate(),
		bindings: {}
	}).name;



// WEBPACK FOOTER //
// ../source/application/grafikon-container/grafikon-container/grafikon-container.js